export const SET_RECORDING_ENABLED = "SET_RECORDING_ENABLED";
export const SET_RECORD_CLASS = "SET_RECORD_CLASS";